import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PersonSingleIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M12.1663 14V12.667C12.1663 12.0925 11.9387 11.5411 11.5326 11.1348C11.1263 10.7285 10.5748 10.5001 10.0003 10.5H6.00033C5.42569 10.5 4.87443 10.7284 4.4681 11.1348C4.06177 11.5411 3.83333 12.0924 3.83333 12.667V14C3.83333 14.2761 3.60948 14.5 3.33333 14.5C3.05719 14.5 2.83333 14.2761 2.83333 14V12.667C2.83333 11.8271 3.1672 11.0216 3.76107 10.4277C4.35493 9.83387 5.16047 9.5 6.00033 9.5H10.0003C10.8401 9.50009 11.6458 9.83395 12.2396 10.4277C12.8332 11.0216 13.1663 11.8273 13.1663 12.667V14C13.1663 14.2761 12.9425 14.5 12.6663 14.5C12.3903 14.4998 12.1663 14.276 12.1663 14Z"
      fill="currentColor"
    />
    <path
      d="M10.1663 4.66699C10.1663 3.47048 9.19679 2.50018 8.00033 2.5C6.80371 2.5 5.83333 3.47038 5.83333 4.66699C5.83351 5.86346 6.80382 6.83301 8.00033 6.83301C9.19668 6.83283 10.1662 5.86335 10.1663 4.66699ZM11.1663 4.66699C11.1662 6.41564 9.74897 7.83283 8.00033 7.83301C6.25153 7.83301 4.83351 6.41574 4.83333 4.66699C4.83333 2.91809 6.25142 1.5 8.00033 1.5C9.74908 1.50018 11.1663 2.9182 11.1663 4.66699Z"
      fill="currentColor"
    />
  </svg>
);
